<template>
  <a-menu
    theme="dark"
    mode="inline"
    :open-keys="filterMenuKeyword? treeHandle.expandkey : openKeys"
    :default-open-keys="openKeys"
    :selected-keys.sync="menuShowKeys.selectedKeys"
    @openChange="handleOpenChange"
    @click="handleMenuClick"
  >
    <template v-for="item in (filterMenuKeyword ? treeHandle.searchTree : listData)">
      <sub-menu
        v-if="item.children && item.children.length"
        :key="item.funcId"
        :menu-info="item"
      />
      <a-menu-item v-else :key="item.funcId" :path="item.url">
        <a-icon
          :type="(JSON.parse(item.param || `{}`) || {}).icon"
          v-if="(JSON.parse(item.param || `{}`) || {}).icon"
        />
        <span>{{ item.name }}</span>
      </a-menu-item>
    </template>
  </a-menu>
</template>

<script>
import { mapState } from "vuex";
import SubMenu from "./SubMenu";
import SearchTree from "@/utils/searchTreeClass";
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: "AsideMenu",
  components: { SubMenu },
  props: {
    collapsed: Boolean,
  },
  data: () => ({
    openKeys: [],
    listData: [],
    treeHandle: new SearchTree({
      childrenProp: "children",
      idProp: "funcId",
      checkFn: (node, searchKey) => {
        let nameFlag = node.name.includes(searchKey);

        return nameFlag;
      },
    }),
  }),
  computed: {
    ...mapState({
      menuList: (state) => state.user.menuList,
      menuMap: (state) => state.user.menuMap,
      filterMenuKeyword: (state) => state.app.filterMenuKeyword,
    }),
    menuShowKeys() {
      let ret = {
        openedKeys: [],
        selectedKeys: [],
      };
      for (let key of Object.keys(this.menuMap)) {
        if (
          !!this.menuMap[key].url &&
          [this.$route.path, this.$route.meta?.parentAuth].includes(
            this.menuMap[key].url
          )
        ) {
          ret.selectedKeys = [key];
          if (!this.collapsed) {
            ret.openedKeys = this.menuMap[key].parentKeys;
          }
          break;
        }
      }
      return ret;
    },
  },
  watch: {
    filterMenuKeyword(val) {
      if (val) {
        this.treeHandle.search(val)
      }
    },
    "menuShowKeys.openedKeys": {
      handler(val) {
        this.openKeys = val.slice();
      },
      immediate: true,
    },
    collapsed: {
      handler(collapsed) {
        setTimeout(() => {
          if (collapsed) {
            this.openKeys = [];
          } else {
            this.openKeys = this.menuShowKeys.openedKeys.slice();
          }
        }, 50);
      },
    },
  },
  created() {},
  mounted() {
    this.listData = cloneDeep(this.menuList)
    this.treeHandle.update(this.listData)
  },
  methods: {
    handleOpenChange(keys) {
      if (keys.length === 1 || keys.length === 0) {
        this.openKeys = keys.slice();
      } else {
        let ret = [];
        let key = keys.pop();
        ret.unshift(key);
        const walk = (key) => {
          let item = this.menuMap[key];
          if (item && item.pid !== "0") {
            ret.unshift(item.pid);
            walk(item.pid);
          }
        };
        walk(key);
        this.openKeys = ret;
      }
    },
    handleMenuClick({ key }) {
      let item = this.menuMap[key];
      const url = item?.url;
      if (!url) {
        return;
      }
      if (url.indexOf("#") === 0) {
        return;
      }
      if (url !== this.$route.path) {
        this.$router.push(item.url);
      }
    },
  },
};
</script>
